/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      }
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - accordion with images
    ========================================================================== */
/* jshint ignore:start */

jQuery.fn.extend({
  mAccord: function (optionsPower) {
    var defaults = {};
    optionsPower = $.extend(defaults, optionsPower);

    return this.each(function () {
      var o = optionsPower,
        trigger = $(this).find(".maTrigger"),
        content = $(this).find(".maContent"),
        obj = $(trigger).prev();

      trigger.click(function (e) {
        var target = $(this).next();
        var $imgURL = $(this).data("url");

        $(this).parent().parent().parent().parent().parent().next().addClass("active");
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .next()
          .children("img")
          .removeClass("active")
          .addClass("hidden");
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .next()
          .children("img")
          .eq($imgURL)
          .addClass("active")
          .removeClass("hidden");

        $(this).addClass("active"), trigger.not(this).removeClass("active"), target.stop().delay(300).slideDown();

        if (target.is(":visible")) {
          $(this).removeClass("active"), target.stop().slideUp();
        } else if (content.not(target).is(":visible")) {
          $(content.not(target)).stop().slideUp();
          setTimeout(function () {
            $("html, body").animate({ scrollTop: target.offset().top - 200 }, "fast");
          }, 700);
        }

        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  jQuery(".mAccord").mAccord();
});
/* jshint ignore:end */

/*  ==========================================================================
    Firefox fix - for testimonial slider
    ========================================================================== */

if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
  $(document).ready(function () {
    $(this).scrollTop(0);
  });
}

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */
const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects, window);
        Waypoint.refreshAll();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */
const effectsInit = function (effects, context) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      context: context,
      offset: "92%"
    });
  });
}; // effectsInit();

setTimeout(function () {
  const effects = document.querySelectorAll(".effect");

  effectsInit(effects, window);
}, 200);


/*  ==========================================================================
  Rellax Scroll animations - scroll effect
========================================================================== */
function rellax__init() {
  var $rellax_items = $(".rellax");
  if ($rellax_items.length > 0) {
    var rellax = new Rellax(".rellax", {
      center: true
    });
  }
} // rellax__init()

rellax__init();
/*  ==========================================================================
  Grid Carousel (Currently used on Featured Posts & Featured People)
========================================================================== */
const gridCarousels = document.querySelectorAll(
  ".row--carousel .owl-carousel:not(.testimonials-carousel):not(.post-carousel)"
);

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      lazyLoad: true
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
  Posts Carousel
========================================================================== */
const postCarousels = document.querySelectorAll(".row--carousel .post-carousel");

const postCarouselInit = function (postCarousels) {
  if (postCarousels.length <= 0) {
    return;
  }

  postCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: false,
      mouseDrag: false,
      touchDrag: false,
      animateIn: "linear",
      animateOut: "linear"
    });

    $(".owl-next").click(function (e) {
      $(".slides--right .slides__shades").first().addClass("slides__shades--active");
      setTimeout(function () {
        jQuery(".slides--right .slides__shades").first().removeClass("slides__shades--active");
      }, 300);
      $(".slides--right").addClass("slides--active");
      $(".slides--left").removeClass("slides--active");
      lazyLoadInstance.update();
    });

    $(".owl-prev").click(function (e) {
      $(".slides--left .slides__shades").first().addClass("slides__shades--active");
      setTimeout(function () {
        jQuery(".slides--left .slides__shades").first().removeClass("slides__shades--active");
      }, 300);
      $(".slides--left").addClass("slides--active");
      $(".slides--right").removeClass("slides--active");
      lazyLoadInstance.update();
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
        lazyLoadInstance.update();
      }, 500);
    });
  });
};
postCarouselInit(postCarousels);

/*  ==========================================================================
  Testimonials Carousel
========================================================================== */

const testimonialsCarousels = document.querySelectorAll(".row--carousel .testimonials-carousel");

const testimonialsCarouselsInit = function (testimonialsCarousels) {
  if (testimonialsCarousels.length <= 0) {
    return;
  }

  testimonialsCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: false,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: false,
      mouseDrag: false,
      touchDrag: false,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      smartSpeed: 250
    });

    let current = $(".featured-testimonials__shades").children().length + 1;

    function disableNav() {
      //actually this function will do something and when processing is done the button is enabled by removing the 'disabled' attribute
      //I use setTimeout so you can see the button can only be clicked once, and can't be clicked again while work is being done
      setTimeout(() => {
        $(".testimonial__bottom__nav").removeAttr("disabled");
      }, 500);
    }

    $(".prev").click(function (e) {
      $(".testimonial__bottom__nav").attr("disabled", "disabled");
      disableNav();
      $(elem).trigger("prev.owl.carousel");
      current++;
      $(".shades-" + (current - 1)).fadeIn();
    });

    $(".next").click(function (e) {
      $(".testimonial__bottom__nav").attr("disabled", "disabled");
      disableNav();
      $(elem).trigger("next.owl.carousel");
      current--;
      $(".shades-" + current).fadeOut();
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // testimonialsCarouselsInit();
testimonialsCarouselsInit(testimonialsCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);
/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__link");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");

      const panel = e.currentTarget.nextElementSibling.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
  NAVIGATION - sitenav dropdown
========================================================================== */
const dropdownLinks = document.querySelectorAll(".sitenav__item[data-sitenavsection]");
const dropdown = document.querySelector(".sitenav__dropdown");
const sitenavSection = document.querySelector(".sitenavsection");

const dropdownlinksInit = function () {
  if (!dropdownLinks) {
    return;
  }

  dropdownLinks.forEach(function (dropdownLink) {
    dropdownLink.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle('sitenav__item--over');
      dropdown.classList.toggle('sitenav__dropdown--active');
      sitenavSection.classList.toggle('sitenavsection--active');
    });
  });
}; // dropdownlinksInit();
dropdownlinksInit();

/*  ==========================================================================
	FILTERS - Company Portfolio Filtering
	========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  window.history.pushState({ path: newUrl }, "", newUrl);

  // if (currentPageUrl !== filterPageURL) {
  //   window.location.href = newUrl;
  // }

  // if (currentPageUrl === filterPageURL && history.pushState) {
  //   window.history.pushState({ path: newUrl }, "", newUrl);
  // }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function () {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    filterUpdateURL(filterData, searchData);

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // get site padder header height
      let siteheaderpadder = document.querySelector(".siteheader--padder");
      let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

      // get teams filter height
      let portFilter = document.querySelector(".filters--portfolio");
      let portFilterHeight = portFilter.offsetHeight;

      let filterPin = document.querySelector(".filters-pin");

      const filterPinRec = filterPin.getBoundingClientRect();

      const top = window.scrollY + filterPinRec.top - portFilterHeight - siteheaderpadderHeight - 40;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      jQuery.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          Waypoint.refreshAll();

          setTimeout(function () {
            const effects = document.querySelectorAll(".effect");

            effectsInit(effects, window);
          }, 200);
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts();

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");

  if (filterForm && filterForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts();

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      if (filterSearch.classList.contains("filters__search--open")) {
        filterSearch.classList.remove("filters__search--open");
      } else {
        filterSearch.classList.add("filters__search--open");
        filterSearchInput.focus();
      }
    });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts();
      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        filterGetPosts();
        filters.classList.toggle("filters--dropdownopen");
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();
